export default {
  host: process.env.VUE_APP_HOST,
  mqtt: process.env.VUE_APP_MQTT_HOST,
  version: process.env.VUE_APP_VERSION,
  check_auth: process.env.VUE_APP_CHECK_AUTH,
  project_title: process.env.VUE_APP_PROJECT_TITLE,
  contact_way: process.env.VUE_APP_CONTACT_WAY,
  app_id: process.env.VUE_APP_APPID,
  copyright: process.env.VUE_APP_COPYRIGHT,
  company: process.env.VUE_APP_COMPANY
}